import React, { useRef, useState } from "react";
import Section from "../components/section";
import Footer from "../components/footer";
import Restricted from "../components/restrictedContent";
import routeConfig from "../routes/routeConfig.json";
import useAuthContext from "../hooks/useAuthContext";
import Panel from "../components/panel";

import "../routes/routeConfig.json";

import { motion, AnimatePresence, useAnimate } from "motion/react";

// const Template = ({ id, children }) => {
//   const { auth, login } = useAuthContext();
//   const [scope, animate] = useAnimate();
//   animate(document.body, { opacity: 1 });

//   let subComponentList = Object.keys(Template);
//   let subComponents = subComponentList.map((key) => {
//     return React.Children.map(children, (child) =>
//       child.type.name === key ? child : null
//     );
//   });

//   return (
//     <Restricted post={{ ...routeConfig[id] }} auth={auth} login={login}>
//       <div className="_caseStudyTemplate flex flex-col w-full">
//         {subComponents.map((component) => component)}
//       </div>
//       <Footer />
//     </Restricted>
//   );
// };

// const Header = ({ id }) => {
//   const post = { ...routeConfig[id] };
//   return (
//     <div style={{ borderColor: post.theme.accent }} className="flex flex-col">
//       <div className="w-full pt-12 flex flex-col justify-cente">
//         <Section>
//           <div className={`w-full flex flex-col justify-center rounded-2xl`}>
//             <img
//               alt=""
//               src={require(`../routes/posts/caseStudies/${post.id}/media/${post.coverImage}`)}
//             />
//           </div>
//         </Section>
//         <Section>
//           <h1 className="mb-4 text-3xl font-serif font-bold text-headingHero">
//             {post.title}
//           </h1>
//           <p className="text-2xl md:text-2xl mb-12">{post.subtitle}</p>
//           <div
//             style={{ backgroundColor: post.theme.accent }}
//             className="h-1 w-16"
//           ></div>
//         </Section>
//       </div>
//     </div>
//   );
// };
// const Introduction = ({ id, children }) => {
//   return (
//     <motion.div className="_introduction flex flex-col justify-center pt-12 md:pt-16 mb-6">
//       <Section>{children}</Section>
//     </motion.div>
//   );
// };
// const Challenge = ({ id, children }) => {
//   const post = { ...routeConfig[id] };
//   return (
//     <motion.div className="flex flex-col lg:px-24 lg:pt-16">
//       <div className="_challenge">
//         <Section>
//           <Panel theme={post.theme}>
//             <h2 className="mb-4 font-bold text-2xl">The challenge</h2>
//             {children}
//           </Panel>
//         </Section>
//       </div>
//     </motion.div>
//   );
// };
// const Body = ({ id, TLDR, children }) => {
//   const post = { ...routeConfig[id] };

//   const renderTLDR = () => (
//     <AnimatePresence mode="wait">
//       <motion.div
//         exit={{ scale: 0.5 }}
//         className="flex flex-col justify-center"
//       >
//         <div className="flex justify-center h-24">
//           <motion.svg
//             initial={{ height: "0%" }}
//             animate={{ height: "100%" }}
//             transition={{ duration: 0.3 }}
//             width="10"
//             // height="100%"
//             version="1.1"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <line
//               x1="5px"
//               y1="0"
//               x2="5px"
//               y2="100%"
//               stroke={post.theme.accent}
//               strokeWidth="5px"
//               strokeDasharray="10px 20px"
//               strokeLinecap="round"
//             />
//           </motion.svg>
//         </div>
//         <motion.div
//           initial={{ scale: 0.6 }}
//           whileInView={{ scale: 1 }}
//           transition={{
//             duration: 0.5,
//             bounce: 0.5,
//             type: "spring",
//           }}
//         >
//           <Section>
//             <Panel theme={post.theme}>
//               <h2 className="mb-4 font-bold text-2xl">TL;DR</h2>
//               {TLDR}
//             </Panel>
//           </Section>
//         </motion.div>
//       </motion.div>
//       <UserOption
//         options={{
//           article: { label: "Full article", component: renderArticle() },
//         }}
//       />
//     </AnimatePresence>
//   );
//   const renderArticle = () => (
//     <AnimatePresence mode="wait">
//       <motion.div
//         exit={{ scale: 0.5 }}
//         className="flex flex-col items-center w-full"
//       >
//         <div className="flex justify-center h-24">
//           <motion.svg
//             initial={{ height: "0%" }}
//             animate={{ height: "100%" }}
//             transition={{ duration: 0.3 }}
//             width="10"
//             // height="100%"
//             version="1.1"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <line
//               x1="5px"
//               y1="0"
//               x2="5px"
//               y2="100%"
//               stroke={post.theme.accent}
//               strokeWidth="5px"
//               strokeDasharray="10px 20px"
//               strokeLinecap="round"
//             />
//           </motion.svg>
//         </div>
//         <motion.div exit={{ scale: 0.5 }}>
//           <motion.div
//             initial={{ y: -96, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             transition={{ delay: 0.5 }}
//             exit={{ scale: 0 }}
//             className="_articleBody pt-12 w-screen shrink-0 flex flex-col"
//           >
//             <h2 className="heroHeading">My role</h2>
//             {children}
//           </motion.div>
//         </motion.div>
//       </motion.div>
//     </AnimatePresence>
//   );

//   const UserOption = ({ options }) => {
//     const [option, setOption] = useState(null);
//     const line = useRef(null);
//     const buttons = useRef(null);
//     const [scope, animate] = useAnimate();

//     const handleAnimate = async (option) => {
//       await animate(buttons.current, { scale: 0.6, opacity: 0 });
//       await animate(line.current, {
//         height: "64px",
//         transition: { duration: 0.3 },
//       });
//       setOption(option);
//     };

//     return (
//       <div ref={scope} className="flex flex-col justify-center">
//         <div ref={line} className="flex justify-center h-12">
//           <svg
//             width="10"
//             height="100%"
//             version="1.1"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <line
//               x1="5px"
//               y1="0"
//               x2="5px"
//               y2="100%"
//               stroke={post.theme.accent}
//               strokeWidth="5px"
//               strokeDasharray="10px 20px"
//               strokeLinecap="round"
//             />
//           </svg>
//         </div>
//         <AnimatePresence>
//           {option === null && (
//             <motion.div
//               ref={buttons}
//               initial={{ scale: 0.6 }}
//               whileInView={{ scale: 1 }}
//               viewport={{ once: true }}
//               // exit={{ scale: 0.6, opacity: 0 }}
//               className="flex justify-center text-lg mb-4 mt-4 font-bold text-link"
//             >
//               <div className="flex gap-[1px] rounded-full border-[2px] overflow-hidden bg-[#0000ee] border-[#0000ee] shadow-[0px_5px_0px_0px_#0000ee]">
//                 {Object.keys(options).map((button, idx) => (
//                   <button
//                     key={idx}
//                     className={`${
//                       option === button
//                         ? "font-bold bg-slate-100"
//                         : "font-normal"
//                     } px-4 py-1 bg-white hover:bg-slate-200`}
//                     onClick={() => {
//                       handleAnimate(button);
//                     }}
//                   >
//                     {options[button].label}
//                   </button>
//                 ))}
//               </div>
//             </motion.div>
//           )}
//         </AnimatePresence>
//         {option !== null && options[option].component}
//       </div>
//     );
//   };

//   return post.tldr ? (
//     <UserOption
//       options={{
//         tldr: { label: "TL;DR", component: renderTLDR() },
//         article: { label: "Full article", component: renderArticle() },
//       }}
//     />
//   ) : (
//     renderArticle()
//   );
// };

// Header.displayName = "Header";
// Introduction.displayName = "Introduction";
// Challenge.displayName = "Challenge";
// Body.displayName = "Body";

// Template.Header = Header;
// Template.Introduction = Introduction;
// Template.Challenge = Challenge;
// Template.Body = Body;

// export default Template;

export default function CasestudyTemplate({ id, children }) {
  const { auth, login } = useAuthContext();
  const [scope, animate] = useAnimate();
  animate(document.body, { opacity: 1 });

  return (
    <Restricted post={{ ...routeConfig[id] }} auth={auth} login={login}>
      <div className="_caseStudyTemplate flex flex-col w-full">{children}</div>
      <Footer />
    </Restricted>
  );
}
export function Header({ id }) {
  const post = { ...routeConfig[id] };
  return (
    <div style={{ borderColor: post.theme.accent }} className="flex flex-col">
      <div className="w-full pt-12 flex flex-col justify-cente">
        <Section>
          <div className={`w-full flex flex-col justify-center rounded-2xl`}>
            <img
              alt=""
              src={require(`../routes/posts/caseStudies/${post.id}/media/${post.coverImage}`)}
            />
          </div>
        </Section>
        <Section>
          <h1 className="mb-4 text-3xl font-serif font-bold text-headingHero">
            {post.title}
          </h1>
          <p className="text-2xl md:text-2xl mb-12">{post.subtitle}</p>
          <div
            style={{ backgroundColor: post.theme.accent }}
            className="h-1 w-16"
          ></div>
        </Section>
      </div>
    </div>
  );
}
export function Introduction({ children }) {
  return (
    <motion.div className="_introduction flex flex-col justify-center pt-12 md:pt-16 mb-6">
      <Section>{children}</Section>
    </motion.div>
  );
}
export function Challenge({ id, children }) {
  const post = { ...routeConfig[id] };
  return (
    <motion.div className="flex flex-col lg:px-24 lg:pt-16">
      <div className="_challenge">
        <Section>
          <Panel theme={post.theme}>
            <h2 className="mb-4 font-bold text-2xl">The challenge</h2>
            {children}
          </Panel>
        </Section>
      </div>
    </motion.div>
  );
}
export function Body({ id, TLDR, children }) {
  const post = { ...routeConfig[id] };

  const renderTLDR = () => (
    <AnimatePresence mode="wait">
      <motion.div
        exit={{ scale: 0.5 }}
        className="flex flex-col justify-center"
      >
        <div className="flex justify-center h-24">
          <motion.svg
            initial={{ height: "0%" }}
            animate={{ height: "100%" }}
            transition={{ duration: 0.3 }}
            width="10"
            // height="100%"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="5px"
              y1="0"
              x2="5px"
              y2="100%"
              stroke={post.theme.accent}
              strokeWidth="5px"
              strokeDasharray="10px 20px"
              strokeLinecap="round"
            />
          </motion.svg>
        </div>
        <motion.div
          initial={{ scale: 0.6 }}
          whileInView={{ scale: 1 }}
          transition={{
            duration: 0.5,
            bounce: 0.5,
            type: "spring",
          }}
        >
          <Section>
            <Panel theme={post.theme}>
              <h2 className="mb-4 font-bold text-2xl">TL;DR</h2>
              {TLDR}
            </Panel>
          </Section>
        </motion.div>
      </motion.div>
      <UserOption
        options={{
          article: { label: "Full article", component: renderArticle() },
        }}
      />
    </AnimatePresence>
  );
  const renderArticle = () => (
    <AnimatePresence mode="wait">
      <motion.div
        exit={{ scale: 0.5 }}
        className="flex flex-col items-center w-full"
      >
        <div className="flex justify-center h-24">
          <motion.svg
            initial={{ height: "0%" }}
            animate={{ height: "100%" }}
            transition={{ duration: 0.3 }}
            width="10"
            // height="100%"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="5px"
              y1="0"
              x2="5px"
              y2="100%"
              stroke={post.theme.accent}
              strokeWidth="5px"
              strokeDasharray="10px 20px"
              strokeLinecap="round"
            />
          </motion.svg>
        </div>
        <motion.div exit={{ scale: 0.5 }}>
          <motion.div
            initial={{ y: -96, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
            exit={{ scale: 0 }}
            className="_articleBody pt-12 w-screen shrink-0 flex flex-col"
          >
            <h2 className="heroHeading">My role</h2>
            {children}
          </motion.div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );

  const UserOption = ({ options }) => {
    const [option, setOption] = useState(null);
    const line = useRef(null);
    const buttons = useRef(null);
    const [scope, animate] = useAnimate();

    const handleAnimate = async (option) => {
      await animate(buttons.current, { scale: 0.6, opacity: 0 });
      await animate(line.current, {
        height: "64px",
        transition: { duration: 0.3 },
      });
      setOption(option);
    };

    return (
      <div ref={scope} className="flex flex-col justify-center">
        <div ref={line} className="flex justify-center h-12">
          <svg
            width="10"
            height="100%"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="5px"
              y1="0"
              x2="5px"
              y2="100%"
              stroke={post.theme.accent}
              strokeWidth="5px"
              strokeDasharray="10px 20px"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <AnimatePresence>
          {option === null && (
            <motion.div
              ref={buttons}
              initial={{ scale: 0.6 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              // exit={{ scale: 0.6, opacity: 0 }}
              className="flex justify-center text-lg mb-4 mt-4 font-bold text-link"
            >
              <div className="flex gap-[1px] rounded-full border-[2px] overflow-hidden bg-[#0000ee] border-[#0000ee] shadow-[0px_5px_0px_0px_#0000ee]">
                {Object.keys(options).map((button, idx) => (
                  <button
                    key={idx}
                    className={`${
                      option === button
                        ? "font-bold bg-slate-100"
                        : "font-normal"
                    } px-4 py-1 bg-white hover:bg-slate-200`}
                    onClick={() => {
                      handleAnimate(button);
                    }}
                  >
                    {options[button].label}
                  </button>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
        {option !== null && options[option].component}
      </div>
    );
  };

  return post.tldr ? (
    <UserOption
      options={{
        tldr: { label: "TL;DR", component: renderTLDR() },
        article: { label: "Full article", component: renderArticle() },
      }}
    />
  ) : (
    renderArticle()
  );
}
